import { CircularProgress, Typography } from "@mui/material";
import { classes } from "common/theme/theme";
import { useTranslation } from "react-i18next";
import React from "react";

/**
 * This component is like `Loading` but it's a small, reusable component without
 * a contour map background or huge carbon logo, and doesn't have an error
 * page stuck to the side of it
 */
export const CarbonLoadingSpinner: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes("flex flex-row gap-4 items-center", className)}>
      <CircularProgress variant="indeterminate" />
      <Typography variant="h5">
        {t("components.Loading.placeholder")}
      </Typography>
    </div>
  );
};
